import moment from 'moment'
moment.locale('ES')

export const dateMixin = {
  methods: {
    dateDDMMYYYY (val) {
      return moment(val).format('DD/MM/YYYY')
    },
    currentDateMilliseconds () {
      return new Date().getTime()
    },
    dateToMilliseconds (val) {
      return new Date(val).getTime()
    },
    dateWithDay (val) {
      // Lunes, 15 Mayo
      return moment(val).format('dddd, DD MMMM')
    }
  }
}
